import { homeJersey, awayJersey } from '@/common/assets';
import TeamTopGoalscorers from './TeamTopGoalscorers';
import type { TopGoalscorersProps } from './TopGoalscorers.types';

export default function TopGoalscorers(props: TopGoalscorersProps) {
  const {
    homeJerseySrc = homeJersey,
    awayJerseySrc = awayJersey,
    homeTopGoalscorers = [],
    awayTopGoalscorers = [],
  } = props;

  const hasHomeAnyGoal = homeTopGoalscorers.some((player) => player.goals > 0);
  const hasAwayAnyGoal = awayTopGoalscorers.some((player) => player.goals > 0);

  // Skip rendering the section if there are no goalscorers for both teams.
  if (!hasHomeAnyGoal && !hasAwayAnyGoal) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      {hasHomeAnyGoal && (
        <TeamTopGoalscorers jerseySrc={homeJerseySrc} topGoalscorers={homeTopGoalscorers} />
      )}
      {hasAwayAnyGoal && (
        <TeamTopGoalscorers jerseySrc={awayJerseySrc} topGoalscorers={awayTopGoalscorers} isAway />
      )}
    </div>
  );
}
